/**
 * Parses the clinic min-upfront floor: `"$X"` → flat dollars, `"Y%"` → percent of outstanding,
 * anything else → 0. MUST stay in sync with api-side min-payment.ts — drift produces a
 * client/server disagreement on whether a plan is fundable.
 */
export function resolveMinUpfront(minPayment: string | null | undefined, outstanding: number): number {
  if (typeof minPayment !== 'string' || minPayment.length === 0 || minPayment === '$') {
    return 0
  }
  if (minPayment.includes('%')) {
    const pct = parseFloat(minPayment.replace('%', ''))
    if (!Number.isFinite(pct) || pct <= 0) {
      return 0
    }
    return roundCents((pct / 100) * outstanding)
  }
  const dollars = parseFloat(minPayment.replace('$', ''))
  if (!Number.isFinite(dollars) || dollars <= 0) {
    return 0
  }
  return roundCents(dollars)
}

function roundCents(n: number): number {
  return Math.round(n * 100) / 100
}
